import React, { useEffect } from 'react'
import connect from 'front-end-core/decorators/connect'
import { requestSearchResults } from 'services/SearchService'
import MultiPageSearch from 'pages/search/MultiPageSearch'

const ConnectedMultiPageSearch = connect(({
  searchPhrase, searchType, pageNumber = 1, pageLimit, flavour, query, aol
}) => ({
  searchResults: requestSearchResults({
    aol,
    searchPhrase,
    searchType,
    pageNumber,
    pageLimit,
    flavour,
    query
  })
}))(props => <MultiPageSearchWrapper {...props} />)

const MultiPageSearchWrapper = (props) => {
  const { setSearchResponse, searchResults } = props

  useEffect(() => {
    setSearchResponse(searchResults)
  }, [searchResults])

  return <MultiPageSearch {...props} />
}
export default ConnectedMultiPageSearch
